export default "__VITE_ASSET__C6GB_675__"